const persistedStateKey = (state) => state.persistedStateKey;
const buildClientList = (state) => state.buildClientList;
const buildIndustryClientList = (state) => state.buildIndustryClientList;
const clientByIndustryLists = (state) => state.clientByIndustryLists;
const clientList = (state) => state.clientList;
const clientOrRareMode = (state) => state.clientOrRareMode;
const companySelectModalState = (state) => state.modalStates.companySelectModalState;
const comparisonMode = (state) => state.comparisonMode;
const comparisonYears = (state) => state.comparisonYears;
const currentClient = (state) => state.requestParams.currentClient;
const currentClientDisplayName = (state) => state.displayData.currentClient;
const currentColors = (state) => state.currentColors;
const currentPage = (state) => state.currentPage;
const currentParamsHash = (state) => state.requestParams.currentParamsHash;
const dataFormat = (state) => state.requestParams.dataFormat;
const datePickerModalState = (state) => state.modalStates.datePickerModalState;
const defaultFromDate = (state) => state.defaultFromDate;
const defaultToDate = (state) => state.defaultToDate;
const fetchBarColor = (state) => (color) => state.colors.bar[color];
const fetchBarColors = (state) => state.colors.sets[state.currentColors].bars;
const fetchTableTextColor = (state) => (comp) => state.colors.tableText[comp];
const fetchTextColor = (state) => (color) => state.colors.text[color];
const fetchTextColors = (state) => state.colors.sets[state.currentColors].text;
const fromDate = (state) => state.requestParams.fromDate;
const industryAverage = (state) => state.requestParams.industryAverage;
const industryAverageLabel = (state) => (key) => state.clientByIndustryLists[key].industryName;
const industryCompAndDecimalException = (state) => (state.comparisonMode === 'industry' && state.requestParams.dataFormat === 'decimal');
const industryLoadingState = (state) => state.modalStates.industryLoadingState;
const industryOverviewParamsExitHash = (state) => state.requestParams.industryOverviewParamsExitHash; // eslint-disable-line
const initialLoad = (state) => (page) => state.initialLoad[page];
const legendData = (state) => state.legendData;
const loadingStatus = (state) => state.modalStates.loadingModal;
const pageTitle = (state) => state.displayData.pageTitle;
const showBurgerMenu = (state) => state.displayData.showBurgerMenu;
const requestParams = (state) => state.requestParams;
const showControlPanel = (state) => state.displayData.showControlPanel;
const showDownloadIcon = (state) => state.displayData.showDownloadIcon;
const showLogoutIcon = (state) => state.displayData.showLogoutIcon;
const showNavigationLinks = (state) => state.displayData.showNavigationLinks;
const summaryLoadingState = (state) => state.modalStates.summaryLoadingState;
const summaryParamsExitHash = (state) => state.requestParams.summaryParamsExitHash;
const toDate = (state) => state.requestParams.toDate;
const totalApplicationsAll = (state) => state.displayData.totalApplications;
const totalApplicationsBase = (state) => state.displayData.totalApplications.Base;
const allClientMode = (state) => state.requestParams.currentClient === 'all';
const singleClientMode = (state) => state.requestParams.currentClient !== 'all';
const rareMode = (state) => state.clientOrRareMode === 'rare';
const tableSortColumn = (state) => state.tableSortColumn;
const pre1Sep2019Mode = (state) => (Date.parse(state.requestParams.fromDate) < Date.parse('2019-09-01'));
const totalApplicationsTotal = (state) => {
  let total = 0;
  Object.entries(state.displayData.totalApplications).forEach(
    (keyValuePairAsArray) => {
      total += keyValuePairAsArray[1];
    },
  );
  return total;
};
const industrySelectState = (state) => {
  let returnVal = '';
  if (state.currentPage === 'IndustryOverview') {
    returnVal = false;
  } else if (Date.parse(state.requestParams.fromDate) < Date.parse('2019-09-01')) {
    returnVal = true;
  } else {
    returnVal = state.industrySelectStateDisabled;
  }
  return returnVal;
};
const getDisplayNameFromUsername = (state) => (client) => {
  let returnValue;
  try {
    returnValue = state.clientList.find(
      (obj) => obj.username === client,
    ).display_name;
  } catch (err) {
    returnValue = client;
  }
  return returnValue;
};
const getUsernameFromDisplayName = (state) => (client) => {
  console.log(client);
  let returnValue;
  try {
    returnValue = state.clientList.find(
      (obj) => obj.display_name === client,
    ).username;
  } catch (err) {
    returnValue = client;
  }
  return returnValue;
};

export default {
  persistedStateKey,
  buildClientList,
  buildIndustryClientList,
  clientByIndustryLists,
  clientList,
  clientOrRareMode,
  pre1Sep2019Mode,
  companySelectModalState,
  comparisonMode,
  comparisonYears,
  currentClient,
  currentClientDisplayName,
  currentColors,
  currentPage,
  currentParamsHash,
  dataFormat,
  datePickerModalState,
  defaultFromDate,
  defaultToDate,
  fetchBarColor,
  fetchBarColors,
  fetchTableTextColor,
  fetchTextColor,
  fetchTextColors,
  getDisplayNameFromUsername,
  getUsernameFromDisplayName,
  fromDate,
  industryAverage,
  industryAverageLabel,
  industryCompAndDecimalException,
  industryLoadingState,
  industryOverviewParamsExitHash,
  industrySelectState,
  initialLoad,
  legendData,
  loadingStatus,
  pageTitle,
  requestParams,
  showBurgerMenu,
  showControlPanel,
  showDownloadIcon,
  showLogoutIcon,
  showNavigationLinks,
  summaryLoadingState,
  summaryParamsExitHash,
  toDate,
  totalApplicationsAll,
  totalApplicationsBase,
  totalApplicationsTotal,
  allClientMode,
  singleClientMode,
  rareMode,
  tableSortColumn,
};
